import React, { FC, useCallback, useState } from 'react';

import i18n from '@yandex-int/i18n';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { SkillAccess } from 'client/model/settings';
import { InstallableApp, Skill } from 'client/model/skill';
import * as keyset from 'i18n/Access';

import { PageLayout } from '../Layout/PageLayout';

import { SharingPageGenerateLink } from './SharingPageGenerateLink';
import { SharingPageUsersList } from './SharingPageUsersList';

interface Props {
    aliceApp: InstallableApp | Skill;
}

const t = i18n(keyset);

export const SharingPage: FC<Props> = ({ aliceApp }) => {
    const [sharingAvailable, setSharingAvailable] = useState<boolean>();

    const handleSharingAvailable = useCallback(
        (isAvailable: boolean) => setSharingAvailable(isAvailable),
        [setSharingAvailable],
    );

    const sharingHidden = !aliceApp.onAir || aliceApp.skillAccess !== SkillAccess.Private;

    return (
        <ErrorBoundary withHomepageLink>
            <PageLayout aliceApp={aliceApp} pageTitle={t('header')}>
                {sharingHidden ? (
                    <div>{t('error-only-private')}</div>
                ) : (
                    <>
                        <SharingPageGenerateLink aliceApp={aliceApp} sharingAvailable={sharingAvailable} />
                        <SharingPageUsersList handleSharingAvailable={handleSharingAvailable} />
                    </>
                )}
            </PageLayout>
        </ErrorBoundary>
    );
};
